import React, { useContext, useEffect, useState } from 'react';
import useDispatchProgramItemService from '../../../app/services/hooks/useDispatchProgramItemService';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { Carrier } from '../../../app/models/Carrier';
import useHandleErrorFields from '../../../hooks/useHandleErrorFields';
import { Guide } from '../../../app/models/DispatchProgramItem';
import DispatchProgramItemDailyCarrierForm from './forms/DispatchProgramItemDailyCarrierForm';
import DispatchProgramItemGuideForm from './forms/DispatchProgramItemGuideForm';
import { Provider } from '../../../app/models/Provider';
import { Truck } from '../../../app/models/Truck';
import { Hopper } from '../../../app/models/Hopper';
import { DailyCarrier } from '../../../app/models/DailyCarrier';
import { AppContext } from '../../../contexts/AppContext';
import { Unit } from '../../../app/models/Unit';
import useSweetAlert from '../../../hooks/useSweetAlert';

interface Props {
    dispatchProgramItemId: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: (message?: string) => void;
    reloadModuleInterlocutor: () => void;
    isWarehouse?: boolean;
}

const DispatchProgramItemCarrierGuideContainer = ({
    dispatchProgramItemId,
    onSaved,
    onCancel,
    onError,
    reloadModuleInterlocutor,
    isWarehouse = false,
}: Props) => {

    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    const {
        getDispatchProgramItemDailyCarriersAvailable,
        updateDispatchProgramCarrierGuide,
        fetchingGetDispatchProgramItemDailyCarriersAvailable,
        fetchingSyncDispatchProgramDailyCarriers,
        getDispatchProgramItemGuide,
        fetchingGetDispatchProgramItemGuide,
        checkGuideFolioExists
    } = useDispatchProgramItemService();

    const [errorFields, setErrorFields] = useState<any>();
    const [dailyCarrier, setDailyCarrier] = useState<DailyCarrier>({});
    const [providers, setProviders] = useState<Provider[]>([]);
    const [trucks, setTrucks] = useState<Truck[]>([]);
    const [hoppers, setHopper] = useState<Hopper[]>([]);
    const [carriers, setCarriers] = useState<Carrier[]>([]);

    const [guide, setGuide] = useState<Guide>({});

    const [getGuideError, setGetGuideError] = useState(false);
    const [getDailyCarrierError, setGetDailyCarrierError] = useState(false);

    const [units, setUnits] = useState<Unit[]>([]);
    const [isTransportForm, setIsTransportForm] = useState(false);
    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    useEffect(() => {
        getList();
    }, []);

    useEffect(() => {
        if(getGuideError && getDailyCarrierError){
            useSweetAlert().errorAlert({
                title: 'Error',
                text: 'Este registro pertenece a una cotización sin confirmar'
            });
            if (onCancel) onCancel();
        }
    }, [getGuideError, getDailyCarrierError]);

    const reloadInterlocutorsTable = () => {
        if (reloadModuleInterlocutor !== undefined) {
            reloadModuleInterlocutor();
        }
    };

    const getList = () => {
        if (showLoading) showLoading('loading', 'Cargando datos...');

        getDispatchProgramItemGuide(dispatchProgramItemId, {
            onSuccess: (response: ServiceResponse) => {
                setGuide(response.data.guide);
                setUnits(response.data.units);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                if (onError) onError(response.message);
                setGetGuideError(true);
            }
        });
        if (showLoading) showLoading('loading', 'Cargando datos...');
        getDispatchProgramItemDailyCarriersAvailable(dispatchProgramItemId, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                const dc = response.data.daily_carrier_selected || {};
                const inferredInternal = Boolean(dc.id) && !dc.provider_id;
                setDailyCarrier({
                    ...dc,
                    is_internal_transport: inferredInternal
                });
                setProviders(response.data.providers);
                const _carriers =  response.data.carriers
                const newCarriers = _carriers.map((carrier: any) => {
                    return {
                        ...carrier,
                        name: `${carrier.rut} ${carrier.name}`
                    };
                });  
                setCarriers(newCarriers);
                setTrucks(response.data.trucks);
                setHopper(response.data.hoppers);
                setUnits(response.data.units);
                setIsTransportForm(response.data.is_transport_form === true);
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                if (onError) onError(response.message);
                setGetDailyCarrierError(true);
            }
        });
    };

    const performUpdate = () => {
        updateDispatchProgramCarrierGuide(
            {
                dispatch_program_item_id: dispatchProgramItemId,
                is_internal_transport: dailyCarrier.is_internal_transport === true,
                provider_id: dailyCarrier.provider_id,
                carrier_id: dailyCarrier.carrier_id,
                truck_id: dailyCarrier.truck_id,
                hopper_id: dailyCarrier.hopper_id,

                file: guide.file,
                folio: guide?.folio,
                total: guide.total,
                tara_total: guide.tara_total ?? undefined,
                actual_dispatch_date: guide.actual_dispatch_date ?? undefined,
                total_unit_id: guide.total_unit_id ?? undefined,
                tara_total_unit_id: guide.tara_total_unit_id ?? undefined
            },
            {
                onSuccess: (response: ServiceResponse) => {
                    toast.success(response.message);
                    if (onSaved) onSaved();
                    reloadModuleInterlocutor();
                    console.log("aquiiii",reloadInterlocutorsTable())
                },
                onError: (response: ServiceResponse) => {
                    if (onError) onError(response.message);
                },
                onFieldError: (errorFields: ServiceResponse) => {
                    setErrorFields(errorFields.data);
                }
            }
        );
    };

    const update = () => {
        if (dailyCarrier.is_internal_transport !== true) {
            if (!dailyCarrier.provider_id) {
                toast.error('Seleccione un proveedor para transporte externo.');
                return;
            }
            if (isTransportForm) {
                if (!dailyCarrier.carrier_id || !dailyCarrier.truck_id || !dailyCarrier.hopper_id) {
                    toast.error('Complete conductor, tracto y tolva para transporte externo.');
                    return;
                }
            }
        }

        // Validar folio antes de guardar
        if (guide.folio) {
            checkGuideFolioExists(guide.folio, guide?.id, {
                onSuccess: (response: ServiceResponse) => {
                    if (response.data?.exists) {
                        // Mostrar confirmación
                        useSweetAlert().requestConfirmation({
                            title: '⚠️ Folio duplicado',
                            text: `Ya existe una guía registrada con el folio "${guide.folio}". ¿Está seguro de que desea registrarlo de igual manera?`,
                            confirmButtonText: 'Sí, registrar',
                            cancelButtonText: 'No, modificar folio',
                            onConfirm: () => performUpdate()
                        });
                    } else {
                        // No existe duplicado, proceder a guardar
                        performUpdate();
                    }
                },
                onError: (response: ServiceResponse) => {
                    // En caso de error, continuar con el guardado
                    console.error('Error al validar folio:', response.message);
                    performUpdate();
                }
            });
        } else {
            // Si no hay folio, guardar directamente
            performUpdate();
        }
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return (
        <>
            <DispatchProgramItemDailyCarrierForm
                dailyCarrier={dailyCarrier}
                setDailyCarrier={setDailyCarrier}
                providers={providers}
                carriers={carriers}
                trucks={trucks}
                hoppers={hoppers}
                errorFields={errorFields}
                isWarehouse={!isTransportForm}
            />
            <DispatchProgramItemGuideForm
                guide={guide}
                setGuide={setGuide}
                errorFields={errorFields}
                units={units}
                guideId={guide?.id}
                isWarehouse={!isTransportForm}
            />
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm
                        callbackCancel={cancel}
                        locked={fetchingSyncDispatchProgramDailyCarriers}
                    />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm
                        callbackSave={update}
                        locked={fetchingSyncDispatchProgramDailyCarriers}
                    />
                </div>
            </div>
        </>
    );
};

export default DispatchProgramItemCarrierGuideContainer;
